import { useTranslation } from "react-i18next";
import { PortalEventContextType, useGetAuthenticatedPortalSourcingEventsQuery } from "../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../common/formatting/useDisplayDateWithTime";
import { urls } from "../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 6;

export const OpenProcurementsPanel = () => {
  const { t } = useTranslation();
  const displayDateWithTime = useDisplayDateWithTime();

  const { data, isLoading, isError } = useGetAuthenticatedPortalSourcingEventsQuery({
    limit: DISPLAY_LIMIT,
    context: PortalEventContextType.Public,
  });
  const events = data?.events ?? [];

  return (
    <HomePanel titleKey="Open procurements" seeAllTo={urls.app.supplier.procurements} isLoading={isLoading} isError={isError} isEmpty={events.length === 0} emptyKey="No open procurements right now">
      <PanelTable headers={[t("Title"), t("Buyer"), t("Deadline")]}>
        {events.map((event) => (
          <PanelRow key={event.id} to={urls.app.supplier.procurement.go(event.id)}>
            <TitleCell title={event.title || t("Untitled")} />
            <MutedCell>{event.buyerName}</MutedCell>
            <MutedCell>
              {event.bidSubmissionDeadline ? displayDateWithTime(event.bidSubmissionDeadline) : "—"}
            </MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
